<template>
  <div
    class="club-discount-banner cursor-pointer"
    data-qa="club_discount_banner"
    @click="emit('click')"
  >
    <div class="d-flex align-center justify-space-between club-discount-banner__inner">
      <div class="d-flex align-center gc-2 text-body-1 text-secondary--text">
        🔥
        <span
          class="text-error--text text-subtitle-1"
          data-qa="club_discount_banner_club_discount_price"
        >-{{ clubDiscountPrice }}</span>
        по клубной цене
      </div>
      <div class="ui-icon-arrow-right text-error--text ml-auto" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { getFormattedPrice } from 'www/utils'

const props = defineProps<{
  fullPrice: number
  totalPrice?: number | null
  cardPrice?: number | null
}>()

type Emits = {
  (_event: 'click'): void
}

const emit = defineEmits<Emits>()

const clubDiscountPrice = computed(() => getFormattedPrice(
  // В totalPrice учитыается цена карты, поэтому нужно добавить стоимость карты
  props.fullPrice - (props.totalPrice ?? 0) + (props.cardPrice ?? 0),
))
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.club-discount-banner {
  padding: 1px;
  border-radius: $border-radius-md;
  background-image: $club-coral-linear-gradient;

  &__inner {
    border-radius: inherit;
    background-color: $ui-kit-bg-gray-0;
    padding: 16px 20px;
  }
}
</style>
